// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f6de00da","171":"c21b716b","453":"da7d551a","456":"829696ec","507":"b8130968","653":"e1675577","801":"b1e995bd","845":"ff8f3dbf"}[chunkId] + ".chunk.js";
};